import * as React from "react";
export default function ForgotPassword() {

  return (
    <>
      ForgotPassword
    </>
  );
}
